<template>
    <v-app id="main" :style="{background: $vuetify.theme.themes[theme].background}">
        <v-app-bar
                app
                color="background"
                dark
                dense
                flat
                hide-on-scroll
                v-if="$vuetify.breakpoint.mdAndUp"
        >
            <div class="d-flex align-center diceboard_title">
                <div>Diceboard</div>
            </div>

            <v-tabs align-with-title>
                <v-tab to="/">Start</v-tab>
                <v-tab to="/games">Games</v-tab>
                <v-tab to="/friends">Friends</v-tab>
                <v-tab to="/profile">Profile</v-tab>
            </v-tabs>

            <v-spacer></v-spacer>
            <template v-if="!user">
                <router-link to="/login">
                    <v-btn class="mr-1 button">
                        Sign In
                    </v-btn>
                </router-link>
                <router-link to="/signup">
                    <v-btn class="button">
                        Sign Up
                    </v-btn>
                </router-link>
            </template>
            <v-menu min-width="200px" bottom nudge-bottom="45px">
                <template v-slot:activator="{ on }">
                    <section>
                        <v-avatar size="40" v-if="user && user.picture_path" class="avatar avatar_small"
                                  v-on="on">
                            <img :src="img_url + user.picture_path" alt="Profilbild"/>
                        </v-avatar>
                        <v-avatar size="40" v-else-if="user" class="avatar _default_small" v-on="on">
                            <v-icon class="avatar_default_small">mdi-account</v-icon>
                        </v-avatar>
                    </section>
                </template>
                <v-list>
                    <router-link to="/profile" v-if="user">
                        <v-list-item-group>
                            <v-list-item>
                                <v-list-item-title>Profil</v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </router-link>
                    <router-link to="/admin" v-if="user && user.admin">
                        <v-list-item-group>
                            <v-list-item>
                                <v-list-item-title>Admin</v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </router-link>
                    <v-list-item-group>
                        <v-list-item v-if="user" @click="logout">
                            <v-list-item-title>Abmelden</v-list-item-title>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-menu>
        </v-app-bar>
      <v-bottom-navigation v-model="bottomNav" class="v-navigation-drawer--bottom" fixed grow v-if="$vuetify.breakpoint.smAndDown" active-class="bottomNavigation">
        <v-btn value="start" to="/" @click="bottomNav = 'start'" class="bottomNavButton">
          <span>Start</span>
          <v-icon>mdi-home-outline</v-icon>
        </v-btn>
        <v-btn value="games" to="/games" @click="bottomNav = 'games'" class="bottomNavButton">
          <span>Games</span>
          <v-icon>mdi-dice-multiple-outline</v-icon>
        </v-btn>
        <v-btn value="friends" to="/friends" @click="bottomNav = 'friends'" class="bottomNavButton">
          <span>Friends</span>
          <v-icon>mdi-account-group-outline</v-icon>
        </v-btn>
        <v-btn value="profile" to="/profile" @click="bottomNav = 'profile'" class="bottomNavButton">
          <span>Profile</span>
          <v-icon>mdi-account-outline</v-icon>
        </v-btn>
      </v-bottom-navigation>

        <v-container class="mb-10">
            <router-view :url="url" v-on:login="getUser" :user="user" @logout="logout" class="mb-10"></router-view>
        </v-container>
      <span class="copyright">
        &copy; {{copyrightYear}}
      </span>
      <router-link :to="{ name: 'imprint'}" class="impressum">
        <a>
          Imprint
        </a>
      </router-link>
    </v-app>
</template>

<script>
    import Vue from 'vue'
    import VueRouter from 'vue-router'
    import Vuex from 'vuex';
    import UserService from "./services/UserService";
    import AuthService from "./services/AuthService";

    Vue.use(VueRouter, Vuex);

    window.api_url = process.env.VUE_APP_API_URL;

    export default {
        name: 'App',
        mounted() {
            this.getUser();
        },
        computed: {
            theme() {
                return (this.$vuetify.theme.dark) ? 'dark' : 'light'
            }
        },
        components: {},

        data: () => ({
            'url': process.env["API_URL "],
            'user': null,
            'img_url': window.api_url + "/storage/image/user/",
            'bottomNav': 'games',
            'copyrightYear' :  new Date().getFullYear(),
        }),
        methods: {
            getUser() {
                this.user = null;
                UserService.getUser()
                    .then(res => {
                        this.user = res.data;
                        UserService.isAdmin();
                    }).catch(() => {
                      this.user = null;
                });
            },
            logout() {
                AuthService.logout();
                this.getUser();
                if (this.$router.currentRoute.path !== "/") {
                    this.$router.push('/');
                }
            },
        }
    }
    ;
</script>


<style lang="scss">
    @import 'https://fonts.googleapis.com/css?family=Ubuntu&display=swap';

    $body-font-family: 'Ubuntu', sans-serif;

    .v-application, .v-application > * {
        font-family: $body-font-family !important;
    }

    .v-card__title {
        word-break: break-word !important;
    }

    a {
        text-decoration: none;
    }

    .bottomNavigation{
      color: var(--v-primary-base) !important;
    }

    .bottomNavButton{
      height: 100% !important;
    }

    .primary_color {
        color: var(--v-primary-base) !important;
    }

    .diceboard_title {
        color: var(--v-primary-base);
        font-size: 22px;
        font-weight: bold;
    }

    h1 {
        font-size: 2em;
    }

    .v-tab {
        letter-spacing: 0.0292857143em !important;
        text-transform: none !important;
        font-weight: bold !important;
        padding: 0 16px !important;
    }

    .button {
        background-color: var(--v-primary-base) !important;
        color: var(--v-background-base) !important;
    }

    .avatar {
        background-color: grey;
    }

    .avatar_small {
        cursor: pointer;
    }

    .avatar_default {
        font-size: 8em !important;
        margin-top: 20px;
        color: var(--v-primary-base) !important;
        opacity: 0.5;
    }

    .avatar_default_small {
        cursor: pointer;
        font-size: 3em !important;
        margin-top: 5px;
        color: var(--v-primary-base) !important;
        opacity: 0.5;
    }

    .impressum{
      position: absolute;
      right: 5px;
      bottom: 5px;
    }

    .copyright{
      position: absolute;
      bottom: 5px;
      left: 5px;
    }
</style>
